// Visual progress tracker for application lifecycle
const STAGES = [
  { key: "Lead Created", label: "Lead" },
  { key: "Documents Pending", label: "Documents" },
  { key: "CarDr Report Pending", label: "CarDr" },
  { key: "Valuation Pending", label: "Valuation" },
  { key: "Underwriting Pending", label: "Underwriting" },
  { key: "Approved", label: "Approved" },
  { key: "Sanction Letter Generated", label: "Sanction" },
  { key: "Disbursed", label: "Disbursed" },
  { key: "Active Loan", label: "Active" },
  { key: "Closed", label: "Closed" },
];

const TERMINAL_REJECT = ["Rejected", "Eligibility Failed"];

export default function ProgressTracker({ status }) {
  if (TERMINAL_REJECT.includes(status)) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-md badge-rejected text-sm font-medium" data-testid="progress-rejected">
        Application Rejected
      </div>
    );
  }
  const currentIdx = STAGES.findIndex(s => s.key === status);
  const idx = currentIdx === -1 ? 0 : currentIdx;

  return (
    <div className="w-full" data-testid="progress-tracker">
      <div className="flex items-center">
        {STAGES.map((s, i) => {
          const isDone = i < idx;
          const isCurrent = i === idx;
          return (
            <div key={s.key} className="flex-1 flex items-center">
              <div className="flex flex-col items-center flex-shrink-0 min-w-0">
                <div className={`w-7 h-7 rounded-full grid place-items-center text-[10px] font-semibold transition-colors ${
                  isDone ? "bg-teal-600 text-white" : isCurrent ? "bg-slate-900 text-white ring-4 ring-slate-200" : "bg-slate-200 text-slate-400"
                }`}>
                  {isDone ? "✓" : i + 1}
                </div>
                <div className={`text-[10px] mt-1.5 truncate max-w-[68px] text-center ${isCurrent ? "text-slate-900 font-semibold" : isDone ? "text-teal-700" : "text-slate-400"}`}>{s.label}</div>
              </div>
              {i < STAGES.length - 1 && (
                <div className={`flex-1 h-0.5 mt-[-12px] ${i < idx ? "bg-teal-600" : "bg-slate-200"}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
